import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { BatchType } from "../../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { batchTypeArraysMap, OrderFrequencyArraysMap } from "../../Resource/Contents";
import { dateParser, IReviewProps } from "../ReviewParser";

export const OrderSetupReview = (props: IReviewProps) => {
    const { data } = props;

    const checkNone = (config) => {
        return typeof config.data != "boolean";
    };
    const orderSetupConfig = () => {
        if (!data) {return [];}
        const config = [
            {
                title: "Batch ID",
                data: data?.BatchId,
            },
            {
                title: "Batch type",
                data: batchTypeArraysMap[data?.BatchType],
            },
            data?.OrderType == BatchType.OneOff && {
                title: "Action date",
                data: dateParser(data?.ActionDate),
            },
            data?.OrderType == BatchType.Standing && {
                title: "Start date",
                data: dateParser(data?.StartDate),
            },
            data?.OrderType == BatchType.Standing && {
                title: "Frequency",
                data: OrderFrequencyArraysMap[data?.Frequency],
            },
            data?.OrderType == BatchType.Standing &&
                data?.ContinueUntilDate && {
                    title: "Continue",
                    data: dateParser(data?.UntilDate),
                },
            data?.OrderType == BatchType.Standing &&
                !data?.ContinueUntilDate && {
                    title: "Continue",
                    data: "Until notified",
                },
        ];
        return config.filter(checkNone);
    };

    return <Typography config={orderSetupConfig()} type="common" />;
};
